import { ResourceNameTypeEnum } from '@bondsports/types';
import { Price } from '@components/molecules/price/price';
import Counter from '@components/organisms/counter/counter';
import { MIN_QUANTITY, NON_QUANTIFIABLE_PRODUCT_TYPES, QUANTITY_DECIMALS } from '../consts';
import type { CartItemProps } from '../types';

type CartItemSummaryProps = Pick<
	CartItemProps,
	'item' | 'onQuantityChange' | 'isLoading' | 'currency' | 'disableQuantityChange'
>;

export const CartItemSummary = ({
	item,
	onQuantityChange,
	isLoading,
	currency,
	disableQuantityChange,
}: CartItemSummaryProps) => {
	const productType = item.product?.productType;
	const isQuantityDisabled =
		disableQuantityChange ||
		(item.resources?.length ?? 0) > 0 ||
		(!!productType && NON_QUANTIFIABLE_PRODUCT_TYPES.includes(productType)) ||
		item.parentResourceType === ResourceNameTypeEnum.RESERVATION;

	const quantity = item.quantity ? Number(item.quantity.toFixed(QUANTITY_DECIMALS)) : MIN_QUANTITY;

	return (
		<div className="row-start-auto flex flex-row items-center justify-between gap-1" data-testid="cart-item-summary">
			<Counter
				value={quantity}
				setValue={value => onQuantityChange?.(item.id, value)}
				min={MIN_QUANTITY}
				disabled={isQuantityDisabled || isLoading}
				aria-label="Item Quantity"
				textProps={{ color: 'black' }}
			/>
			<Price price={item.price!} currency={currency} />
		</div>
	);
};
